// extracted by mini-css-extract-plugin
export default {"btnWrap":"PointPayment_btnWrap__iIvPo","applyBtnWrap":"PointPayment_applyBtnWrap__25SJ4"};